<template>
  <h1>Text Replace (Simply)</h1>
  <el-row style="margin-bottom: 20px;">
    <el-col
      :span="24"
    >
      <div
        class="grid-content"
        style="padding: 20px; background-color: #1a1a1a"
      >
        <el-form
          ref="form"
          :model="form"
          label-width="120px"
        >
          <el-form-item
            label="Input"
            class="el-form-item-label"
          >
            <el-input
              v-model="input"
              type="textarea"
              :rows="10"
              placeholder="Please input"
            />
          </el-form-item>
          <el-form-item
            label="Before"
            class="el-form-item-label"
          >
            <el-input
              v-model="before"
              type="text"
              placeholder="Please input before word"
              style="width: 70%;"
            />
          </el-form-item>

          <el-form-item
            label="After"
            class="el-form-item-label"
          >
            <el-input
              v-model="after"
              type="text"
              placeholder="Please input after word"
              style="width: 70%;"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              style="float: right"
              type="primary"
              @click="onClickReplaceButton"
            >
              Replace
            </el-button>
          </el-form-item>
          <el-form-item>
            <div style="text-align: center;">
              <i
                class="el-icon-arrow-down"
                style="font-size: 2em;"
              />
            </div>
          </el-form-item>
          <el-form-item
            label="Output"
          >
            <el-input
              v-model="output"
              type="textarea"
              :rows="10"
              readonly
            />
          </el-form-item>
          <el-form-item>
            <el-button
              style="float: right"
              type="success"
              @click="onClickCopyButton"
            >
              Copy
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
  <el-row style="margin-bottom: 20px;">
    <el-col :span="24">
      <el-table
        :data="tableData"
        style="width: 100%;"
        :header-cell-style="{ background: '#121212'}"
        :cell-style="{ background: '#1a1a1a' }"
        :border="false"
      >
        <el-table-column
          prop="date"
          label="Date"
          width="120"
        />
        <el-table-column
          prop="name"
          label="Version"
          width="80"
        />
        <el-table-column
          prop="description"
          label="Description"
        />
      </el-table>
    </el-col>
  </el-row>
</template>

<script type="ts">
//import {defineComponent, ref} from "vue";
import {defineComponent, ref} from "vue";

export default defineComponent ({
  name: "TextReplace",
  setup() {
    return {
      input: ref(''),
      output: ref(''),
      before: ref(''),
      after: ref(''),
      tableData: [{
        date: '2021/03/17',
        name: '0.9.1',
        description: 'init'
      }]
    }
  },
  methods: {
    onClickReplaceButton() {
      let before = this.before
      let after = this.after
      let value = this.input
      if (value && before) {
        //let reg = new RegExp('ab+c');
        this.output = value.split(before).join(after)
        this.$message({
          message: 'Replaced.',
          type: 'success'
        });
      } else {
        this.output = ''
      }
    },
    onClickCopyButton() {
      let text = this.output
      navigator.clipboard.writeText(text).catch((e) => {
        console.error(e)
      })
      this.$message({
        message: 'Copied.',
        type: 'success'
      });
    }

  }
})
</script>

<style scoped>
/*.el-row {*/
/*  margin-bottom: 20px;*/
/*&:last-child {*/
/*   margin-bottom: 0;*/
/* }*/
/*}*/
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
h1 {
  color: white;
}

.grid-content form.el-form .el-form-item label {
  color: white;
}
.el-form-item-label .el-form-item__label {
  color: white;
}


.item-label label { color: wheat; }

.el-table .version-table-row {
  background-color: pink;
}
.el-table .version-table-header {
  background-color: lightblue;
  color: #fff;
  font-weight: 500;
}


</style>